import React from 'react';
import { useDarkMode } from '../DarkModeContext';

const PDFViewerModal = ({ pdfUrl, chapterTitle, onClose }) => {
  const { dark } = useDarkMode();
  
  const handleDownloadPDF = () => {
    // Open the PDF in a new tab for viewing/downloading
    window.open(pdfUrl, '_blank');
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div 
        className={`
          ${dark ? 'bg-gray-800' : 'bg-white'} 
          rounded-lg w-full h-full max-w-6xl max-h-[90vh] 
          flex flex-col shadow-2xl
        `}
        onClick={(e) => e.stopPropagation()}
      >
        
        {/* Modal Header */}
        <div className={`
          flex justify-between items-center p-4 border-b
          ${dark ? 'border-gray-700 bg-gray-700' : 'border-gray-200 bg-gray-50'}
        `}>
          <h2 className={`text-lg font-semibold ${dark ? 'text-white' : 'text-gray-900'}`}>
            {chapterTitle} - PDF Preview
          </h2>
          
          <div className="flex items-center gap-3">
            <button
              onClick={handleDownloadPDF}
              className={`
                flex items-center gap-2 px-3 py-2 rounded-lg text-sm font-medium
                transition-colors duration-200
                ${dark 
                  ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                  : 'bg-blue-500 hover:bg-blue-600 text-white'
                }
              `}
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download PDF
            </button>
            
            <button
              onClick={onClose}
              className={`
                p-2 rounded-lg transition-colors duration-200
                ${dark 
                  ? 'bg-gray-600 hover:bg-gray-500 text-gray-200' 
                  : 'bg-gray-200 hover:bg-gray-300 text-gray-800'
                }
              `}
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 overflow-hidden">
          <iframe
            src={`${pdfUrl}#toolbar=1&navpanes=1&scrollbar=1`}
            className="w-full h-full border-0"
            title={`${chapterTitle} PDF`}
            style={{ background: dark ? '#1f2937' : '#f8fafc' }}
          >
            {/* Fallback for browsers that don't support iframe PDF viewing */}
            <div className={`
              flex flex-col items-center justify-center h-full p-8 text-center
              ${dark ? 'bg-gray-800 text-gray-200' : 'bg-gray-50 text-gray-800'}
            `}>
              <svg className="w-16 h-16 mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <p className="mb-4 text-lg">Your browser doesn't support PDF viewing.</p>
              <a 
                href={pdfUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className={`
                  inline-flex items-center gap-2 px-4 py-2 rounded-lg font-medium
                  transition-colors duration-200
                  ${dark 
                    ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                    : 'bg-blue-500 hover:bg-blue-600 text-white'
                  }
                `}
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </svg>
                Open PDF in New Tab
              </a>
            </div>
          </iframe>
        </div>
      </div>
    </div>
  );
};

export default PDFViewerModal;